module.exports = __webpack_public_path__ + "img/ear-ke.095b62c2.png";